function createPluginExportReader(exportName) {
    return function readPluginExport(module) {
        return module[exportName];
    };
}

function loadDraggablePlugin() {
    return import("gsap/Draggable").then(createPluginExportReader("Draggable"));
}

function loadDrawSvgPlugin() {
    return import("gsap/DrawSVGPlugin").then(createPluginExportReader("DrawSVGPlugin"));
}

function loadEaselPlugin() {
    return import("gsap/EaselPlugin").then(createPluginExportReader("EaselPlugin"));
}

function loadFlipPlugin() {
    return import("gsap/Flip").then(createPluginExportReader("Flip"));
}

function loadGsDevToolsPlugin() {
    return import("gsap/GSDevTools").then(createPluginExportReader("GSDevTools"));
}

function loadInertiaPlugin() {
    return import("gsap/InertiaPlugin").then(createPluginExportReader("InertiaPlugin"));
}

function loadMotionPathPlugin() {
    return import("gsap/MotionPathPlugin").then(createPluginExportReader("MotionPathPlugin"));
}

function loadMotionPathHelperPlugin() {
    return import("gsap/MotionPathHelper").then(createPluginExportReader("MotionPathHelper"));
}

function loadMorphSvgPlugin() {
    return import("gsap/MorphSVGPlugin").then(createPluginExportReader("MorphSVGPlugin"));
}

function loadObserverPlugin() {
    return import("gsap/Observer").then(createPluginExportReader("Observer"));
}

function loadPhysics2DPlugin() {
    return import("gsap/Physics2DPlugin").then(createPluginExportReader("Physics2DPlugin"));
}

function loadPhysicsPropsPlugin() {
    return import("gsap/PhysicsPropsPlugin").then(createPluginExportReader("PhysicsPropsPlugin"));
}

function loadPixiPlugin() {
    return import("gsap/PixiPlugin").then(createPluginExportReader("PixiPlugin"));
}

function loadScrambleTextPlugin() {
    return import("gsap/ScrambleTextPlugin").then(createPluginExportReader("ScrambleTextPlugin"));
}

function loadScrollToPlugin() {
    return import("gsap/ScrollToPlugin").then(createPluginExportReader("ScrollToPlugin"));
}

function loadScrollSmootherPlugin() {
    return import("gsap/ScrollSmoother").then(createPluginExportReader("ScrollSmoother"));
}

function loadScrollTriggerPlugin() {
    return import("gsap/ScrollTrigger").then(createPluginExportReader("ScrollTrigger"));
}

function loadSplitTextPlugin() {
    return import("gsap/SplitText").then(createPluginExportReader("SplitText"));
}

function loadTextPlugin() {
    return import("gsap/TextPlugin").then(createPluginExportReader("TextPlugin"));
}

function loadCustomEasePlugin() {
    return import("gsap/CustomEase").then(createPluginExportReader("CustomEase"));
}

function loadCustomBouncePlugin() {
    return import("gsap/CustomBounce").then(createPluginExportReader("CustomBounce"));
}

function loadCustomWigglePlugin() {
    return import("gsap/CustomWiggle").then(createPluginExportReader("CustomWiggle"));
}

let easePackModulePromise = null;

function loadEasePackModule() {
    if (!easePackModulePromise) {
        easePackModulePromise = import("gsap/EasePack").catch(
            function handleEasePackLoadFailure(error) {
                easePackModulePromise = null;
                throw error;
            },
        );
    }
    return easePackModulePromise;
}

function loadRoughEasePlugin() {
    return loadEasePackModule().then(createPluginExportReader("RoughEase"));
}

function loadExpoScaleEasePlugin() {
    return loadEasePackModule().then(createPluginExportReader("ExpoScaleEase"));
}

function loadSlowMoPlugin() {
    return loadEasePackModule().then(createPluginExportReader("SlowMo"));
}

export const PLUGIN_REGISTRY = {
    draggable: { name: "Draggable", loader: loadDraggablePlugin, requires: [] },
    drawsvg: { name: "DrawSVG", loader: loadDrawSvgPlugin, requires: [] },
    easel: { name: "Easel", loader: loadEaselPlugin, requires: [] },
    flip: { name: "Flip", loader: loadFlipPlugin, requires: [] },
    gsdevtools: { name: "GSDevTools", loader: loadGsDevToolsPlugin, requires: [] },
    inertia: { name: "Inertia", loader: loadInertiaPlugin, requires: [] },
    motionpath: { name: "MotionPath", loader: loadMotionPathPlugin, requires: [] },
    motionpathhelper: {
        name: "MotionPathHelper",
        loader: loadMotionPathHelperPlugin,
        requires: ["MotionPath"],
    },
    morphsvg: { name: "MorphSVG", loader: loadMorphSvgPlugin, requires: [] },
    observer: { name: "Observer", loader: loadObserverPlugin, requires: [] },
    physics2d: { name: "Physics2D", loader: loadPhysics2DPlugin, requires: [] },
    physicsprops: { name: "PhysicsProps", loader: loadPhysicsPropsPlugin, requires: [] },
    pixi: { name: "Pixi", loader: loadPixiPlugin, requires: [] },
    scrambletext: { name: "ScrambleText", loader: loadScrambleTextPlugin, requires: [] },
    scrollto: { name: "ScrollTo", loader: loadScrollToPlugin, requires: [] },
    scrollsmoother: {
        name: "ScrollSmoother",
        loader: loadScrollSmootherPlugin,
        requires: ["ScrollTrigger"],
    },
    scrolltrigger: { name: "ScrollTrigger", loader: loadScrollTriggerPlugin, requires: [] },
    splittext: { name: "SplitText", loader: loadSplitTextPlugin, requires: [] },
    text: { name: "Text", loader: loadTextPlugin, requires: [] },
    roughease: { name: "RoughEase", loader: loadRoughEasePlugin, requires: [] },
    exposcaleease: { name: "ExpoScaleEase", loader: loadExpoScaleEasePlugin, requires: [] },
    slowmo: { name: "SlowMo", loader: loadSlowMoPlugin, requires: [] },
    customease: { name: "CustomEase", loader: loadCustomEasePlugin, requires: [] },
    custombounce: { name: "CustomBounce", loader: loadCustomBouncePlugin, requires: ["CustomEase"] },
    customwiggle: { name: "CustomWiggle", loader: loadCustomWigglePlugin, requires: ["CustomEase"] },
};

export const PLUGIN_ALIASES = {
    eases: ["RoughEase", "ExpoScaleEase", "SlowMo"],
};
